import { useState } from "react";
import { Loader2, ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function ResetPasswordPage() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Le password non corrispondono"); return; }
    if (password.length < 6) { setError("Minimo 6 caratteri"); return; }
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Errore reset password");
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
        <div className="text-center">
          <p className="text-red-400 text-sm">Link non valido. Richiedi un nuovo reset dalla pagina di login.</p>
          <a href="/" className="text-[#6E93C7] text-sm mt-4 inline-block hover:underline">Torna al login</a>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
        <div className="text-center">
          <h1 className="text-2xl font-black text-white mb-2">Password aggiornata</h1>
          <p className="text-zinc-400 text-sm mb-4">Ora puoi accedere con la nuova password.</p>
          <a href="/" className="inline-block px-6 py-2 bg-white text-zinc-900 font-bold rounded-sm hover:bg-zinc-200 transition-colors text-sm">Accedi</a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-black text-white tracking-tight">
            SIACASA <span className="text-[#6E93C7]">HUB</span>
          </h1>
          <p className="text-zinc-500 text-sm mt-2">Reimposta la tua password</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-zinc-900 border border-zinc-800 rounded-sm p-6 space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs tracking-wider uppercase font-semibold text-zinc-400">Nuova password</Label>
            <Input
              data-testid="reset-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Minimo 6 caratteri"
              className="h-10 rounded-sm bg-zinc-800 border-zinc-700 text-white placeholder:text-zinc-600"
              required
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs tracking-wider uppercase font-semibold text-zinc-400">Conferma password</Label>
            <Input
              data-testid="reset-confirm"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Ripeti la password"
              className="h-10 rounded-sm bg-zinc-800 border-zinc-700 text-white placeholder:text-zinc-600"
              required
            />
          </div>
          {error && (
            <div className="text-sm text-red-400 bg-red-950/50 border border-red-900 rounded-sm px-3 py-2">{error}</div>
          )}
          <Button
            data-testid="reset-submit"
            type="submit"
            disabled={loading}
            className="w-full h-10 bg-white text-zinc-900 font-bold rounded-sm hover:bg-zinc-200 transition-colors"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Reimposta Password"}
          </Button>
        </form>

        <a href="/" className="flex items-center gap-1 justify-center text-zinc-500 hover:text-zinc-300 text-sm mt-4 transition-colors">
          <ArrowLeft className="w-3.5 h-3.5" /> Torna al login
        </a>
      </div>
    </div>
  );
}
